module.exports = __webpack_public_path__ + "img/1.da7816c3.svg";